<template>
	<div>
		<h4 class="text-center">Supplier Payment</h4>
		<b-form-row>
			<b-form-group class="col-md-3" label="Fecha servicio desde *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.pickupStartDate}"
						reset-button
						size="sm"
						v-model="filters.pickupStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Hasta *">
				<b-form-datepicker
						locale="es"
						:class="{'active-filter':filters.pickupEndDate}"
						reset-button
						size="sm"
						v-model="filters.pickupEndDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Proveedor *">
				<multiselect
						:class="{'active-filter':filters.supplierId.length>0}"
						v-model="filters.supplierId"
						:options="suppliersOpts"
						label="text"
						placeholder="Seleccione 1 opción"
				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Estado de servicio">
				<multiselect
						:class="{'active-filter':filters.status.length>0}"
						v-model="filters.status"
						:options="statusOpts"
						group-label="group"
						group-values="options"
						group-select
						multiple
						label="text"
						track-by="value"
						placeholder="Todos"
						taggable
				/>
			</b-form-group>
		</b-form-row>

		<b-form-row>
			<b-overlay :show="loadingExport"  no-wrap rounded> </b-overlay>
			<b-col class="text-right mt-2" >
				<b-button v-if="$hasPermission('report.show')" @click="search()" variant="primary" class="mr-2"><md-icon icon="search"/> Generar</b-button>
				<b-button v-if="$hasPermission('report.export.xls')" @click="excel()" variant="success" class="mr-2"><md-icon icon=""/>Xls</b-button>
				<b-button v-if="$hasPermission('report.export.pdf')" @click="pdf()" variant="danger" class="mr-2"><md-icon icon="picture_as_pdf"/></b-button>
			</b-col>
		</b-form-row>


		<b-row v-if="loading">
			<div >
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
			</div>
		</b-row>
		<b-row  v-if="!loading" >
			<b-col class="col-md-12">
				<div id="msg">
					<h6 v-if="totalRecords===-1">Seleccione las opciones para generar el reporte</h6>
					<h6 v-if="totalRecords>0">Se encontrarón {{totalRecords}} rides</h6>
					<h6 v-if="totalRecords===0">No se encontraron registros</h6>
				</div>
				<div class="table-responsive async-tables" v-if="totalRecords>0">
					<b-table  hover v-html="html">

					</b-table>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import api from '../../../../api.js'
	import Multiselect from 'vue-multiselect';
	export default {
		name: "supplier-payments",
		components:{Multiselect},
		data(){
			return {
				loading:false,
				loadingExport:false,
				html:"",
				totalRecords:-1,
				codeReport : "supplier-payments",
				filters:{
					status:[],
					pickupStartDate:"",
					pickupEndDate:"",
					supplierId: []
				},
			}
		},
		methods:{
			search(){
				this.loading = true
				this.html= "";
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters
					}
				}).then((res) => {
					this.totalRecords = res.data.totalRegistros??0;
					this.html = (this.totalRecords)?res.data.html:"";
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loading = false});
			},

			excel(){
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters,
						format:"excel"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadExcel(res,"Remittance-payment");
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loadingExport = false});

			},
			pdf(){
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filters,
						format:"pdf"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadPdf(res,"Remittance-payment");
				}).catch(error => {
					this.$root.handleRequestError(error)
					this.exportLoading = false
				}).finally(()=>{this.loadingExport = false});

			}
		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['suppliersOpts']})
		},
		computed:{
			suppliersOpts(){
				let aux = [...this.$root.auxVars.suppliersOpts];
				return aux ;
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts}]
			}
		}

	}
</script>

<style scoped>

</style>
